
import { Link } from 'react-router-dom';

export default function FeaturedRetreats() {
  const retreats = [
    {
      id: 1,
      name: 'Alpine Vista Retreat',
      location: 'Rocky Mountain National Park, Colorado',
      price: '$450',
      rating: 4.9,
      reviews: 127,
      image: 'https://public.readdy.ai/ai/img_res/ba2e3675db8e99ce4c69f71b4fbe0ac1.jpg',
      features: ['Hot Tub', 'Mountain Views', 'Hiking Trails', 'Stargazing'],
      type: 'Premium'
    },
    {
      id: 2,
      name: 'Redwood Forest Haven',
      location: 'Humboldt County, California',
      price: '$380',
      rating: 4.8,
      reviews: 89,
      image: 'https://readdy.ai/api/search-image?query=Elegant%20safari%20tent%20among%20towering%20redwood%20trees%20in%20California%20forest%2C%20dappled%20sunlight%20through%20canopy%2C%20wooden%20walkway%20and%20deck%2C%20luxury%20forest%20accommodation%20with%20natural%20materials%2C%20peaceful%20woodland%20setting%20with%20modern%20comforts&width=600&height=400&seq=redwood-haven-001&orientation=landscape',
      features: ['Forest Bathing', 'Wildlife Viewing', 'Spa Services', 'Gourmet Dining'],
      type: 'Eco-Luxury'
    },
    {
      id: 3,
      name: 'Desert Star Sanctuary',
      location: 'Moab, Utah',
      price: '$520',
      rating: 4.9,
      reviews: 156,
      image: 'https://readdy.ai/api/search-image?query=Premium%20desert%20glamping%20tent%20under%20starry%20night%20sky%20in%20Utah%20red%20rock%20country%2C%20warm%20ambient%20lighting%2C%20luxury%20desert%20accommodation%20with%20modern%20amenities%2C%20dramatic%20rock%20formations%20silhouetted%20against%20stars%2C%20high-end%20outdoor%20hospitality&width=600&height=400&seq=desert-star-001&orientation=landscape',
      features: ['Stargazing Deck', 'Rock Climbing', 'Astronomy Tours', 'Desert Spa'],
      type: 'Adventure'
    }
  ];

  return (
    <section className="py-20 bg-white" data-product-shop>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Featured <span className="text-emerald-600">Glamping Retreats</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Handpicked luxury accommodations that offer the perfect blend of outdoor adventure and premium comfort for unforgettable experiences.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-12">
          {retreats.map((retreat) => (
            <div key={retreat.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 group">
              <div className="relative h-64 overflow-hidden">
                <img 
                  src={retreat.image} 
                  alt={retreat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-4 left-4 bg-emerald-600 text-white px-3 py-1 rounded-full text-sm font-medium">
                  {retreat.type}
                </div>
                <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm rounded-full p-2 cursor-pointer hover:bg-white transition-colors">
                  <i className="ri-heart-line text-gray-700 text-lg"></i>
                </div>
              </div>
              
              <div className="p-6">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="text-xl font-bold text-gray-900">{retreat.name}</h3>
                  <div className="flex items-center space-x-1">
                    <i className="ri-star-fill text-yellow-400 text-sm"></i>
                    <span className="text-sm font-medium text-gray-700">{retreat.rating}</span>
                  </div>
                </div>
                
                <div className="flex items-center text-gray-600 mb-4">
                  <i className="ri-map-pin-line text-emerald-600 mr-2"></i>
                  <span className="text-sm">{retreat.location}</span>
                </div>

                <div className="flex flex-wrap gap-2 mb-4">
                  {retreat.features.map((feature, index) => (
                    <span key={index} className="bg-gray-100 text-gray-700 px-3 py-1 rounded-full text-xs font-medium">
                      {feature}
                    </span>
                  ))}
                </div>

                <div className="flex items-center justify-between">
                  <div>
                    <span className="text-2xl font-bold text-gray-900">{retreat.price}</span>
                    <span className="text-gray-600 text-sm">/night</span>
                    <div className="text-xs text-gray-500">{retreat.reviews} reviews</div>
                  </div>
                  <Link 
                    to="/book"
                    className="bg-emerald-600 text-white px-6 py-2 rounded-lg font-semibold hover:bg-emerald-700 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Book Now
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link 
            to="/retreats"
            className="inline-flex items-center bg-gray-900 text-white px-8 py-3 rounded-lg font-semibold hover:bg-gray-800 transition-colors cursor-pointer"
          >
            View All Retreats
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}